import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import TournamentsPage from './pages/tournaments/TournamentsPage';
import TournamentDetailPage from './pages/tournaments/tournament-view/TournamentDetailPage';
import TournamentCreateWizard from './pages/tournaments/tournament-creation/TournamentCreateWizard';
import RankingPage from './pages/ranking/RankingPage';
import RankingManagementPage from './pages/ranking-management/RankingManagementPage';
import RankingCreateWizard from './pages/ranking-management/RankingCreateWizard';
import NewsEditionPage from './pages/news/NewsEditionPage';
import ClasesPage from './pages/clases/ClasesPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/tournaments' element={<TournamentsPage></TournamentsPage>} />
      <Route path='/tournaments/new' element={<TournamentCreateWizard />} />
      <Route path='/tournaments/edit/:torIdParam' element={<TournamentCreateWizard />} />
      <Route path='/tournaments/:torId' element={<TournamentDetailPage />} />
      <Route path='/ranking' element={<RankingPage></RankingPage>} />
      <Route path='/ranking-management' element={<RankingManagementPage />} />
      <Route path='/ranking-management/new' element={<RankingCreateWizard />} />
      <Route path='/ranking-management/edit/:rkgIdParam' element={<RankingCreateWizard />} />
      <Route path='/ranking-management/view/:rkgIdParam' element={<RankingCreateWizard readOnly />} />
      <Route path='/news' element={<NewsEditionPage></NewsEditionPage>} />
      <Route path='/clases' element={<ClasesPage />} />
      <Route path='/config' element={<h1>Config Page</h1>} />
    </Routes>
  );
};

export default AppRoutes;
